import DkRegulation from "./dk_regulation";

export default class MrgreenDenmarkRegulation extends DkRegulation {
    static CLASS = 'MrgreenDenmarkRegulation';
}
